module.exports = __webpack_public_path__ + "img/cdz1.583f08cf.png";